module.exports = __webpack_public_path__ + "media/somedayoroneday.2c44061a.mp3";